import React from 'react';
import { Event } from '../../../../stores/events';
import style from './styles.module.scss';

const EventLocation: React.FC<{ record: Event }> = React.memo(({ record }) => (
    <div className={style.location_container}>
        {record.latitude && record.longitude ? (
            <div className={style.location_text}>
                {record.latitude.toFixed(4)}, {record.longitude.toFixed(4)}
            </div>
        ) : (
            <div className={style.location_text}>No location set</div>
        )}
    </div>
));
EventLocation.displayName = 'EventLocation';

export default EventLocation;
